import React from 'react';

import heroLogo from '../../assets/hero-logo.png';
import * as S from './IntroducingMypartner.styles';

const IntroducingMypartner = ({onStartBooking}) => {
  return (
    <S.IntMypartnr>
      <S.IntMypartnrWrapper>
        <S.IntMypartnrIcon>
          <img src={heroLogo} alt="hero logo" />
        </S.IntMypartnrIcon>
        <S.IntMypartnrHdng>
          Start your journey to become a <span>myPartner HERO</span> and use your{' '}
          <span>HERO benefits to grow your business!</span>
        </S.IntMypartnrHdng>
        {/*<S.IntMypartnrCta onClick={onStartBooking}><span>Start Booking</span></S.IntMypartnrCta>*/}
      </S.IntMypartnrWrapper>
    </S.IntMypartnr>
  );
};

export default IntroducingMypartner;
